import firebase from "gatsby-plugin-firebase"
import "firebase/auth";
import "firebase/database";
import "firebase/storage";
import "firebase/firestore";

import {navigate} from 'gatsby'

export const watchStock = () => {
  var con = firebase.firestore().collection("/Products");

  con.onSnapshot((doc) => {
    doc.docs.forEach((prod) => {
      
      console.info(prod.data());
    });
  });

  
};



export const isNewUser = () => {

    var user = firebase.auth().currentUser;
    if(user !== null){
        firebase.database().ref("/Members/" + user.uid).once("value").then((snapshot) => {
            var ID = snapshot.child("/ID/doc").exists();
            var verEmail = snapshot.child("/verifiedEmail").val();
            var profilePic = snapshot.child("/profileURL").val();

           

            if(ID && (verEmail || user.emailVerified) && profilePic !== "")
            {
                console.log("verified user")
                firebase.database().ref('/Members/' + user.uid).update({ New: false, Points: 100});
                return true
            }
        })

        
        return false
    }
    return false
}

export const notificationList = () => {

    var list = firebase.functions().httpsCallable('adminNotifications');
      list({})
        .then((result) => {
          return result
        })
}

export const isRegistered = (uid) => {
   
    var isRegistedT = firebase.functions().httpsCallable('memberExists')
      isRegistedT({uid: uid})
        .then((result) => {{
          var isUser = result.data.isUser;
          if(!isUser){
            navigate('/Signup')
            
            return false
          }
          else{
            navigate('/MembersArea/Profile')
            
            return true
          }

        }}).finally(() => {return true}).catch((err) => {
          console.log(err)
        })
}

export const verifiedAge = (uid, filename,) => {
    

    var db = firebase.database();

    var storageRef = firebase.storage().ref();

    var memberRef = storageRef.child("/MemberProfiles/" + uid + "/ID/");
    var imageRef = memberRef.child(filename)
    var Member = db.ref('/Members/' + uid + "/ID/");

    imageRef.getDownloadURL().then(url => { Member.set({ doc: JSON.stringify(url) }) })
}

export const uploadAgeDocs = (uid, file) => {
    window.localStorage.setItem("Filename", JSON.stringify(file.name))

    var storageRef = firebase.storage().ref();

    var memberRef = storageRef.child("/MemberProfiles/" + uid + "/ID/");

    var imageRef = memberRef.child(file.name)

    imageRef.put(file).then(snapshot => {
        verifiedAge(uid, file.name)
        window.localStorage.setItem("Filename", JSON.stringify(file.name))
    })

}